import { createReducer, on } from '@ngrx/store';
import * as UserActions from '../actions/user.actions';

export const userFeatureKey = 'user';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(UserActions.loadUser, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(UserActions.loadUserSuccess, (state, action) => ({
    record: action.data.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(UserActions.loadUserFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(UserActions.clearUserState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

